import { mergeWithConfig } from "@/lib/dimensions";
import {
  dimensionByQuizId,
  DimensionByQuizIdRequestParams,
} from "@/requests/questionnaries/dimension-by-quiz-id.request";
import { TopicWithRefreshStatus } from "@/types/questionnaries";
import { useQuery } from "@tanstack/react-query";
import { useDimensionByQuizId } from "./dimension-by-quiz-id.hook";

export const buildTopicByIdQueryKey = (variables: TopicByIdVariables) => {
  return [
    "companies",
    variables.companyId,
    "quiz",
    variables.applicationQuizId,
    "dimension",
    variables.dimension,
    "topic",
    variables.topicId,
  ];
};

export type TopicByIdVariables = DimensionByQuizIdRequestParams & {
  topicId: string;
};

export const useTopicById = (variables: TopicByIdVariables) => {
  const { data: dimensionSummary } = useDimensionByQuizId({
    companyId: variables.companyId,
    applicationQuizId: variables.applicationQuizId,
    dimension: variables.dimension,
  });

  const dimension = dimensionSummary ? mergeWithConfig(dimensionSummary) : null;

  return useQuery({
    queryKey: buildTopicByIdQueryKey(variables),
    queryFn: async (): Promise<TopicWithRefreshStatus | undefined> => {
      const dimensionDetails = await dimensionByQuizId(variables);

      const topic = dimensionDetails.topics?.find(
        (topic) => topic.topic === variables.topicId,
      );

      if (topic) {
        return {
          ...topic,
          needsRefresh: false,
        };
      }
    },
    initialData: (): TopicWithRefreshStatus | undefined => {
      const topic = dimension?.topics?.find(
        (topic) => topic.topic === variables.topicId,
      );

      if (topic) {
        return {
          ...topic,
          needsRefresh: false,
        };
      }
    },
    enabled: Object.values(variables).every(Boolean),
  });
};
